import isEmpty from 'lodash/isEmpty';
import { useState, useEffect } from 'react';

import { productsForOrder } from '../../store/cart';

import styles from './ProductChoices.module.scss';

export default function ProductComment({ product, setProduct }) {
  const [comments, setComments] = useState('');
  const [productsInCart, setProductsInCart] = useState();

  function updateCart() {
    const productWithComment = {
      ...product,
      userComments: comments,
    };
    setProduct(productWithComment);
    if (isEmpty(productsInCart)) return;
    const productsInCartOption = productsInCart.map(_product => {
      if (_product._id !== product._id) return _product;
      return productWithComment;
    });
    productsForOrder.update(productsInCartOption);
  }

  useEffect(() => {
    const productsForOrder$ = productsForOrder.subscribe(setProductsInCart);
    return () => productsForOrder$.unsubscribe();
  }, []);

  useEffect(() => {
    if (!product) return;
    setComments(product.userComments || '');
  }, [product]);

  function onBlurComment() {
    updateCart();
  }

  function onChangeComment(e) {
    setComments(e.target.value);
  }

  return (
    <div>
      <p className={styles.optionsTitle}>Σχόλια προϊόντος</p>
      <textarea
        className={styles.textArea}
        name="userComments"
        id="userComments"
        placeholder="Θέλετε να προσέξουμε κάτι;"
        onChange={onChangeComment}
        value={comments}
        onBlur={onBlurComment}
      />
    </div>
  );
}
